<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/store/modules/user'
import { useLocationStore } from '@/store/modules/location'
import { addUserFrom, getLocationByIp } from '@/api/user'
import { getSessionId } from '@/utils/token'
import KeFu from '@/components/keFu/keFu.vue'

const userStore = useUserStore()
const locationStore = useLocationStore()
const route = useRoute()

const FROM_CODE_KEY = 'fromCode'
const FROM_USER_ID_KEY = 'fromUserId'

// 记录游客来源（参考 UniApp common.js addUserFrom2）
const recordUserFrom = async () => {
  const query: Record<string, string> = {}
  Object.entries(route.query).forEach(([k, v]) => {
    const val = Array.isArray(v) ? v[0] : v
    if (val != null) query[k] = String(val)
  })
  if (query.from) localStorage.setItem(FROM_CODE_KEY, query.from)
  if (query.fromUserId) localStorage.setItem(FROM_USER_ID_KEY, query.fromUserId)

  try {
    const res = await addUserFrom({
      fromCode: localStorage.getItem(FROM_CODE_KEY) || '',
      fromUserId: Number(localStorage.getItem(FROM_USER_ID_KEY)) || 0,
      mobile: '{}',
      page: route.path,
      options: Object.keys(query).length ? JSON.stringify(query) : '',
      version: 'WEB',
      scene: 'H5',
    }) as any
    // 设置 sessionId：200 取 data，600/601 取 msg
    if (!getSessionId()) {
      if (res?.code === 200 && res.data) {
        userStore.setSessionId(res.data)
      } else if ((res?.code === 600 || res?.code === 601) && res.msg) {
        userStore.setSessionId(res.msg)
      }
    }
  } catch {}
}

onMounted(async () => {
  // 首次进入及站内每次跳转都记录
  watch(() => route.fullPath, recordUserFrom, { immediate: true })

  // IP 定位
  try {
    const res = await getLocationByIp() as any
    if (res?.data) {
      locationStore.setLocation(res.data)
    }
  } catch {}
})
</script>

<template>
  <router-view :key="$route.path" />
  <KeFu />
</template>
